var map = {
	"./color.service.js": "75ee",
	"./config.service.js": "d42c",
	"./customer.service.js": "f012",
	"./customerContact.service.js": "cb61",
	"./manufacture.service.js": "6208",
	"./order.service.js": "f57d",
	"./product.service.js": "a8c4",
	"./quota.service.js": "19d7",
	"./receipt.service.js": "e50a",
	"./role.service.js": "6485",
	"./service.js": "666a",
	"./tem.service.js": "489a",
	"./upload.service.js": "13fe",
	"./user.service.js": "5259",
	"./user.service2.js": "f72c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bc11";